/**
* CLASS EncuestaClientes
*
* Contiene el contenedor principal de las encuestas de Clientes
*
* @author Hector Morales <hector.morales@ikarosofttechnology.com>
*/

import React, { Component } from 'react';
import DataGrid from '../data_grid/DataGrid';
import TBar from '../tbar/TBar';

class EncuestaClientes extends Component {
    retrocederPanel(){
        this.props.funcionClick('PanelMenu');
    }
  	render() {     
        let sqlParams = { 
                            fieldSearch : [
                                'nombre',                                
                            ], 
                            sqlWhere : [
                                " AND tipo='cliente'"
                            ],                                                      
                            filtroFechas : "false",                                                 
                        };                 
        return (//carga el componente que contiene la grilla de datos 
            <div>
                <TBar
                    items={[
                              {
                                  type : 'boton',
                                  icon : 'arrow_back',
                                  width : '100px',
                                  height : '60px',
                                  title : 'Atras',
                                  display : true,
                                  function : this.retrocederPanel.bind(this)
                              },
                          ]}
                    length = '1'
                />
                <div style={{top: "60px",position:"relative"}}>            
                    <DataGrid titulo='Encuesta de Clientes' 
                              funcionClick={this.props.funcionClick} 
                              parametro={this.props.parametro}
                              colsData={[ 
                                            {
                                                type  : 'bd',
                                                label : 'Pregunta',
                                                field : 'nombre'
                                            },
                                        ]} 
                              sqlParams = { sqlParams }
                              automatica="true"
                              botonNuevo="true"
                              formFields={[
                                            {
                                                label : 'Pregunta *',
                                                field : 'nombre',
                                                type  : 'text',
                                                validation : 'texto_mayusculas',
                                                required : 'true',
                                                longitud : 100,
                                                tooltip : 'Ingrese el titulo de la pregunta'  
                                            },
                                            {
                                                label : '',
                                                field : 'tipo',
                                                type  : 'hidden',
                                                validation : '',
                                                value : 'cliente',
                                                required : 'true'                                        
                                            },                                                                             
                                        ]}                     
                              apiField={'encuesta_terceros_preguntas'}
                              mainContainer='EncuestaClientes'/> 
                </div>
            </div>             
        )
    } 
}

export default EncuestaClientes